import {CommandBase} from '@shared/commands/command-base';
import {TransactionConfig} from '../transaction.config';
import {Guid} from 'guid-typescript';
import {ChangeReportTransaction} from '../../models/change-report-transaction.model';

export class TransactionImportCommand extends CommandBase {
  public publicationId: string;
  public fileType: string;

  constructor(public fileId: string, public replaceExistingSelection: boolean) {
    super(TransactionConfig.TransactionImportApi);
    this.publicationId = Guid.create().toString();
    this.fileType = 'Excel';
    this.projectId = '[PROJECT_ID]';
  }
}

export class TransactionAddCommand extends CommandBase {
  constructor(public transactions: ChangeReportTransaction[]) {
    super(TransactionConfig.TransactionAddApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class ResetTransactionsFromProjectSettingsCommand extends CommandBase {
  constructor() {
    super(TransactionConfig.ResetTransactionsFromProjectSettingsApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class TransactionDeleteCommand extends CommandBase {
  constructor(public transactions: ChangeReportTransaction[]) {
    super(TransactionConfig.TransactionDeleteApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class PostTopicsCommand extends CommandBase {
  constructor(public Topics: any[]) {
    super(TransactionConfig.PostTopicsApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class CreateTransactionsBetweenMyCountriesCommand extends CommandBase {
  constructor() {
    super(TransactionConfig.CreateTransactionsBetweenMyCountriesApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class DeleteAllTransactionCommand extends CommandBase {
  constructor() {
    super(TransactionConfig.DeleteAllTransactionApi);
    this.projectId = '[PROJECT_ID]';
  }
}


